'use client';

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import Header, { SmallHeader } from '@nib-components/header';
import Footer, { SmallFooter } from '@nib-components/footer';
import GrowLayout from '@nib-components/grow-layout';
import { SkipLink, Target } from '@nib-components/skip-link';
import { ChatLauncher } from '@nib/chatbot-launcher';
export const validVariationValues = ['arhi', 'shareholders', 'nz', 'foundation', 'thrive', 'providers', 'international', 'internationalStudents', 'internationalWorkers', 'gu'];
const Wrapper = styled.div`
  height: 100%;
  position: relative;
`;
const MainGrowLayoutContent = props => /*#__PURE__*/_jsx(GrowLayout.Content, {
  as: "main",
  ...props
}); // eslint-disable-line  @typescript-eslint/no-explicit-any
const isReactNode = component => /*#__PURE__*/React.isValidElement(component);
const HeaderFooterLayout = _ref => {
  let {
    children,
    headerConfig,
    footerConfig,
    variation = 'arhi',
    header,
    footer,
    smallLayout = false,
    showSmallHeaderMenu = false,
    enableSearch,
    hideHeaderPhoneNumber,
    hideSmallFooterPhoneNumber,
    flex,
    isCorporate = false,
    invertSmallHeader = false,
    invert = false,
    nzShielded,
    withAbsoluteLinks = false,
    absoluteBaseUrl,
    enableNibby,
    nibbyOptions,
    forceHideAcknowledgementOfCountry,
    containerWidth,
    ...otherProps
  } = _ref;
  const defaultHeader = smallLayout ? SmallHeader : Header;
  const defaultFooter = smallLayout ? SmallFooter : Footer;
  const ConfiguredHeader = header ? header : defaultHeader; // eslint-disable-line  @typescript-eslint/no-explicit-any
  const ConfiguredFooter = footer ? footer : defaultFooter; // eslint-disable-line  @typescript-eslint/no-explicit-any
  // Invert if either prop is true
  const invertHeaderOrSmallHeader = invert || invertSmallHeader;
  return /*#__PURE__*/_jsxs(Wrapper, {
    "data-mesh-component": "HEADER-FOOTER-LAYOUT",
    ...otherProps,
    children: [/*#__PURE__*/_jsx(SkipLink, {
      link: "#content",
      text: "Skip to content"
    }), /*#__PURE__*/_jsxs(GrowLayout.Wrapper, {
      children: [header && isReactNode(header) ?
      // No props are passed to node header prop
      // If we wanted props, we could use React.cloneElement
      header :
      // We need to pass both `invert` and `invertSmallHeader` as we don't know if `ConfiguredHeader` is the `Header` component or `SmallHeader`
      /*#__PURE__*/
      _jsx(ConfiguredHeader, {
        config: headerConfig,
        variation: variation,
        showMenu: showSmallHeaderMenu,
        enableSearch: enableSearch,
        hidePhoneNumber: hideHeaderPhoneNumber,
        isCorporate: isCorporate,
        invertSmallHeader: invertHeaderOrSmallHeader,
        invert: invertHeaderOrSmallHeader ? invertHeaderOrSmallHeader : undefined,
        withAbsoluteLinks: withAbsoluteLinks,
        absoluteBaseUrl: absoluteBaseUrl,
        containerWidth: containerWidth
      }), /*#__PURE__*/_jsx(Target, {
        id: "content",
        component: MainGrowLayoutContent,
        flex: flex,
        children: children
      }), footer && isReactNode(footer) ? footer : /*#__PURE__*/_jsx(ConfiguredFooter, {
        config: footerConfig,
        variation: variation,
        isCorporate: isCorporate,
        nzShielded: nzShielded,
        withAbsoluteLinks: withAbsoluteLinks,
        absoluteBaseUrl: absoluteBaseUrl,
        forceHideAcknowledgementOfCountry: forceHideAcknowledgementOfCountry,
        hidePhoneNumber: hideSmallFooterPhoneNumber,
        containerWidth: containerWidth
      }), enableNibby && /*#__PURE__*/_jsx(ChatLauncher, {
        ...nibbyOptions
      })]
    })]
  });
};
HeaderFooterLayout.displayName = 'HeaderFooterLayout';
export default HeaderFooterLayout;